import ServerApi from "@/services/ServerApi";

export default {
  sendErrorEmail(error) {
    return ServerApi.post("/send-error-email", error);
  },
};
